const selectors = {
    resetPasswordForm: '#RecoverPasswordFormCustom',
    resetPasswordInput: '#RecoverEmail',
    resetPasswordSuccessInvite: '#InviteSuccess'
}
class ResetPasswordCustom extends HTMLElement {
    constructor() {
        super()
        this.container = this;
        this.resetPasswordForm = this.container.querySelector(selectors.resetPasswordForm);
        this.resetInput = this.container.querySelector(selectors.resetPasswordInput);
        this.successInvite = this.container.querySelector(selectors.resetPasswordSuccessInvite);
        this.initResetPasswordCustom();
    }
    initResetPasswordCustom() {
        this.onResetPasswordFormSubmit();
    }
    async onResetPasswordFormSubmit() {
        let form = this.resetPasswordForm;
        let input_email = this.resetInput
        let success_invite_message = this.successInvite;
        let button_reset = document.getElementById('reset-password-button');
        button_reset.addEventListener('click', async function(event) {
            event.preventDefault();
            let url = '/apps/datajet/task/65cc92e889dc1f11db565e35'
            let email = {
                email: input_email.value
            };
            let response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(email)
            });
            let responseJson = await response.json();
            if (responseJson.status == 'CUSTOMER_EXIST') {
                form.submit();
            }
            if (responseJson.status == 'CUSTOMER_NOT_EXIST') {
                form.submit();
            }
            if (responseJson.status == 'CUSTOMER_INVITED') {
                success_invite_message.classList.remove('hidden');
                input_email.value = '';
            }
        });
    }
}

customElements.define('reset-password', ResetPasswordCustom);